import { FeedModel } from "../../models/FeedModel";
import FeedProvider from "../provider/FeedProvider";
import Feed from "./Feed";

export default function FeedWidget(feed: FeedModel) {
  return (
    <FeedProvider feed={feed}>
      <Feed 
        itemsPerRowSmall={feed.itemsPerRowSmall} 
        itemsPerRowMedium={feed.itemsPerRowMedium} 
        itemsPerRowLarge={feed.itemsPerRowLarge} 
        defaultImage={feed.defaultImage}
      />
    </FeedProvider>
  )
}